import boxComponent from '../core/chart-components/box';
import pointComponent from '../core/chart-components/point';
import pieComponent from '../core/chart-components/pie';
import gridLineComponent from '../core/chart-components/grid';
import refLineComponent from '../core/chart-components/ref-line';
import axisComponent from '../core/chart-components/axis';
import containerComponent from '../core/chart-components/container';
import textComponent from '../core/chart-components/text';
import scrollbarComponent from '../core/chart-components/scrollbar';
import brushRangeComponent from '../web/components/brush-range';
import rangeComponent from '../core/chart-components/range';
import brushLassoComponent from '../core/chart-components/brush-lasso';
import labelsComponent from '../core/chart-components/labels';
import categoricalLegend from '../core/chart-components/legend-cat';
import sequentialLegend from '../core/chart-components/legend-seq';
import lineComponent from '../core/chart-components/line';
import brushAreaComponent from '../web/components/brush-area';
import tooltipComponent from '../web/components/tooltip';
import { debugCollider, debugPathToPoints } from '../core/chart-components/debug';

export default [
  boxComponent,
  pointComponent,
  pieComponent,
  gridLineComponent,
  refLineComponent,
  axisComponent,
  containerComponent,
  textComponent,
  scrollbarComponent,
  brushRangeComponent,
  rangeComponent,
  brushLassoComponent,
  labelsComponent,
  categoricalLegend,
  sequentialLegend,
  lineComponent,
  brushAreaComponent,
  tooltipComponent,
  debugCollider,
  debugPathToPoints,
];
